<section [id]="id" class="section" [ngClass]="theme">
  <div class="container">
    <div *ngIf="titre" class="section-title">{{ titre }}</div>
    <div *ngIf="sousTitre" class="section-subtitle">{{ sousTitre }}</div>
    <!-- Contenu dynamique injecté -->
    <div class="section-content">
      <ng-content></ng-content>
    </div>
  </div>
</section>
